import styled from 'styled-components';

export const TextWrapper = styled.span`
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.text.primary};
  line-height: 20px;
  .normalTitle {
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    color: ${({ theme }) => theme.text.title};
    @media only screen and (max-width: 350px) {
      font-size: 16px;
    }
  }
  .bigTitle {
    font-size: 64px;
    line-height: 70px;
    font-weight: ${({ theme }) => theme.fontWeight.medium};
    color: ${({ theme }) => theme.text.primary};
  }
  .h1 {
    font-size: 36px;
    line-height: 42px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.text.primary};
  }
  .h1SemiBold {
    font-size: 36px;
    line-height: 42px;
    font-weight: ${({ theme }) => theme.fontWeight.semibold};
    color: ${({ theme }) => theme.text.primary};
  }
  .h2 {
    font-size: 30px;
    line-height: 42px;
    font-weight: ${({ theme }) => theme.fontWeight.medium};
    color: ${({ theme }) => theme.text.primary};
  }
  .h3 {
    font-size: 24px;
    line-height: 32px;
    font-weight: ${({ theme }) => theme.fontWeight.semibold};
    color: ${({ theme }) => theme.text.primary};
  }
  .h4 {
    font-size: 20px;
    line-height: 28px;
    font-weight: ${({ theme }) => theme.fontWeight.semibold};
    color: ${({ theme }) => theme.text.primary};
  }
  .h4White {
    font-size: 20px;
    line-height: 28px;
    font-weight: ${({ theme }) => theme.fontWeight.semibold};
    color: white;
  }
  .h5Gray {
    font-size: 16px;
    line-height: 24px;
    font-weight: ${({ theme }) => theme.fontWeight.semibold};
    color: ${({ theme }) => theme.color.gray};
  }
  .h5 {
    font-size: 16px;
    line-height: 24px;
    font-weight: ${({ theme }) => theme.fontWeight.semibold};
    color: ${({ theme }) => theme.text.primary};
  }
  .buttonWhite {
    font-size: 14px;
    line-height: 22px;
    font-weight: ${({ theme }) => theme.fontWeight.medium};
    color: white;
  }
  .button {
    font-size: 14px;
    line-height: 22px;
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    color: ${({ theme }) => theme.text.primary};
  }
  .buttonGray {
    font-size: 14px;
    line-height: 22px;
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    color: ${({ theme }) => theme.color.gray};
  }
  .bodyGray {
    font-size: 14px;
    line-height: 22px;
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    color: ${({ theme }) => theme.color.gray};
  }
  .bodyHighLight {
    font-size: 14px;
    line-height: 22px;
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    color: ${({ theme }) => theme.text.highlight};
  }
  .body {
    font-size: 14px;
    line-height: 22px;
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    color: ${({ theme }) => theme.text.primary};
  }
  .inputDisabled {
    font-size: 12px;
    line-height: 20px;
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    color: ${({ theme }) => theme.text.disabled};
  }
  .input {
    font-size: 12px;
    line-height: 20px;
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    color: ${({ theme }) => theme.text.primary};
  }
  .inputWhite {
    font-size: 12px;
    line-height: 20px;
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    color: white;
  }
  .text {
    font-size: 12px;
    line-height: 20px;
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    color: ${({ theme }) => theme.text.primary};
  }
  .smallText {
    font-size: 10px;
    line-height: 15px;
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    color: ${({ theme }) => theme.text.lightPrimary};
  }
  .txtUnderline {
    text-decoration-line: 'underline';
  }
  .light {
    ${({ theme }) => theme.fontWeight.light};
  }
  .medium {
    font-weight: ${({ theme }) => theme.fontWeight.medium};
  }
  .bold {
    font-weight: ${({ theme }) => theme.fontWeight.bold};
  }
  .semiBold {
    font-weight: ${({ theme }) => theme.fontWeight.semibold};
  }
  .left {
    text-align: left;
  }
  .center {
    text-align: center;
  }
  .right {
    text-align: right;
  }
  .inline {
    display: inline;
  }
`;
